import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { F as FlexBox } from './Flex.styles-CHWNVWnx.js';

const Flex = ({
  children,
  alignContent = 'normal',
  alignItems = 'flex-start',
  basis,
  columnGap,
  direction = 'row',
  shrink,
  order,
  grow,
  justifyContent = 'flex-start',
  padding = 'none',
  paddingBlockEnd,
  paddingBlockStart,
  paddingInlineEnd,
  paddingInlineStart,
  fullWidth = false,
  rowGap,
  wrap = 'nowrap',
  gap = 'none',
  ...rest
}) => /*#__PURE__*/React__default.createElement(FlexBox, _extends({}, rest, {
  $basis: basis,
  $direction: direction,
  $alignContent: alignContent,
  $justifyContent: justifyContent,
  $alignItems: alignItems,
  $columnGap: columnGap,
  $grow: grow,
  $order: order,
  $rowGap: rowGap,
  $shrink: shrink,
  $wrap: wrap,
  $fullWidth: fullWidth,
  $gap: gap,
  padding: padding,
  paddingBlockEnd: paddingBlockEnd,
  paddingBlockStart: paddingBlockStart,
  paddingInlineEnd: paddingInlineEnd,
  paddingInlineStart: paddingInlineStart,
  square: true
}), children);

export { Flex as F };
//# sourceMappingURL=Flex-DIrgiHUL.js.map
